module.exports = __webpack_public_path__ + "img/twitter-color.dfb454e9.svg";